export default __webpack_public_path__ + "static/media/VerificationX.e48bea30.svg";